/**
 * Wire types for leases — derived from `serializeLease` / `serializeLeaseRow`
 * (refactor/backend/src/modules/tenants/serializers.ts:62-96).
 */
import type { Unit } from './property';

/** Django `tenants.models.LeaseStatus`. */
export const LEASE_STATUSES = [
  'PENDING',
  'ACTIVE',
  'EXPIRED',
  'TERMINATED',
  'OVERDUE',
  'EVICTED',
] as const;
export type LeaseStatus = (typeof LEASE_STATUSES)[number];

/** `LeaseSerializer` — serializers.ts:63-81. `unit_info` nests the full `Unit`. */
export interface Lease {
  id: number;
  unit: number;
  unit_info: Unit;
  property_name: string;
  tenant: number;
  tenant_name: string;
  start_date: string | null;
  end_date: string | null;
  rent_amount: string;
  security_deposit: string;
  status: LeaseStatus;
  lease_document: string | null;
  notes: string;
  created_at: string;
  updated_at: string;
}

/** `LeaseListSerializer` — serializers.ts:84-96. */
export interface LeaseListRow {
  id: number;
  tenant_name: string;
  unit_number: string;
  property_name: string;
  start_date: string | null;
  end_date: string | null;
  rent_amount: string;
  status: LeaseStatus;
  created_at: string;
}

/** `leaseCreateSchema` on write (serializers.ts:154-164). */
export interface LeaseCreateRequest {
  unit: number;
  tenant: number;
  /** 'YYYY-MM-DD' — DRF `DateField` input format. */
  start_date: string;
  end_date: string;
  rent_amount: number | string;
  security_deposit?: number | string | undefined;
  status?: LeaseStatus | undefined;
  lease_document?: string | null | undefined;
  notes?: string | undefined;
}

/** `leasePatchSchema` — every field of `LeaseCreateRequest`, optional. */
export type LeasePatchRequest = Partial<LeaseCreateRequest>;
